import React, { useState } from "react";
import { useSelector } from "react-redux";

import { selectSession } from "../../store/features/adminSlice";
import { publicLinks } from "../../store/network routes/paths";
import Style from "./shareLinks.module.scss";

// The three pages anyone can open with nothing but the link: the live board,
// the auction pool and the teams board. Each carries the session id, which is
// what scopes it to this auction, so there is nothing to sign in to and
// nothing to set up for the people watching.
//
// Only shown while a session exists, because the links have no session to
// point at before one is started and stop resolving once it is cleared.
const ShareLinks = () => {
  const session = useSelector(selectSession);
  const [copied, setCopied] = useState("");

  if (!session?.sessionId) return null;

  const links = publicLinks(session.sessionId);

  const copy = async (link) => {
    try {
      await navigator.clipboard.writeText(link.url);
      setCopied(link.key);
      setTimeout(() => setCopied(""), 1600);
    } catch (e) {
      // Clipboard access is refused on an insecure origin and in some
      // browsers, so the link stays selectable on the row either way.
      setCopied("");
    }
  };

  return (
    <div className={Style.card}>
      <div className={Style.head}>
        <div>
          <div className={Style.title}>Share this auction</div>
          <div className={Style.sub}>
            Open to anyone with the link. No sign in, and read only.
          </div>
        </div>
        <div className={Style.session}>
          <span className={Style.sessionLabel}>Session</span>
          <span className={Style.sessionId}>{session.sessionId}</span>
        </div>
      </div>

      <ul className={Style.list}>
        {links.map((link) => (
          <li key={link.key} className={Style.row}>
            <div className={Style.rowText}>
              <div className={Style.rowName}>{link.text}</div>
              <div className={Style.rowHint}>{link.hint}</div>
              <div className={Style.rowUrl}>{link.url}</div>
            </div>

            <div className={Style.rowActions}>
              <button
                type="button"
                className={Style.copyBtn}
                onClick={() => copy(link)}
              >
                {copied === link.key ? "Copied" : "Copy link"}
              </button>
              <a
                className={Style.openBtn}
                href={link.url}
                target="_blank"
                rel="noreferrer"
              >
                Open
              </a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ShareLinks;
